import React from 'react';
import { ChevronLeft, ChevronRight, UserPlus } from 'lucide-react';

const NavigationButtons = ({ currentStep, prevStep, nextStep, loading, handleSubmit }) => {
  return (
    <div className="flex justify-between mt-8">
      {currentStep > 1 && (
        <button
          type="button"
          onClick={prevStep}
          className="inline-flex items-center px-6 py-3 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 transition-colors"
        >
          <ChevronLeft className="h-5 w-5 mr-2" />
          Précédent
        </button>
      )}
      {currentStep < 3 ? (
        <button
          type="button"
          onClick={nextStep}
          className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-lg text-white bg-[#202654] hover:bg-[#202654]/90 transition-colors"
        >
          Suivant
          <ChevronRight className="h-5 w-5 ml-2" />
        </button>
      ) : (
        <button
          type="submit"
          disabled={loading}
          className="inline-flex items-center px-6 py-3 border border-transparent text-sm font-medium rounded-lg text-white bg-[#202654] hover:bg-[#202654]/90 disabled:opacity-50 transition-colors"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white mr-2"></div>
              Enregistrement...
            </>
          ) : (
            <>
              <UserPlus className="h-5 w-5 mr-2" />
              Enregistrer l'inscription
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default NavigationButtons;
